module.exports = __webpack_public_path__ + "img/20180128144135.41a3b1c5.jpg";